import React, { useState } from 'react';
import TauriMenuChildren from './TauriMenuChildren/TauriMenuChildren';
import { Link } from 'react-router-dom';

const TauriMenuHeader = ({ subMenu, submenuIconStyle, submenuStyle, toggleMenu, handleMouseLeave, handleSubmenuItemClicked, submenuRef, onClick }) => {
    const handleClick = (hasSubmenu, child, parent) => {
        handleSubmenuItemClicked(hasSubmenu, child, parent);
    };

    return (
        <ul ref={submenuRef} className="submenu" style={submenuStyle}>
            {subMenu.map((subItem, index) => (
                <li>
                    <div className="item-list px-3 py-1">
                        <Link key={index} to={`${subItem.path}/${subItem.id}`} onMouseEnter={toggleMenu} onMouseLeave={handleMouseLeave} onClick={(e) => { e.stopPropagation(); onClick && onClick(subItem); }}>
                            {subItem.icon && (
                                <img src={`${process.env.PUBLIC_URL}${subItem.icon}`} style={submenuIconStyle} alt="Icon"/>
                            )}
                            {subItem.name}
                            {subItem.children && <span className="dropdown-icon">&#9658;</span>}
                        </Link>
                    </div>
                    {/* To render the children */}
                    {subItem.children && (
                        <TauriMenuChildren
                            subMenu={subItem.children}
                            submenuIconStyle={submenuIconStyle}
                            toggleMenu={toggleMenu}
                            handleMouseLeave={handleMouseLeave}
                            handleClick={handleClick}
                            submenuStyle={submenuStyle}
                            parent={subItem}
                        />
                    )}
                </li>
            ))}
        </ul>
    );
};

export default TauriMenuHeader;
